import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { productFilterTypes } from 'types/PDPTypes';
import PDPUpholsteryFiltersUI from './PDPUpholsteryFiltersUI';
const PDPUpholsteryFilters = t0 => {
  const $ = _c(13);
  const {
    className,
    clearAllFiltersButton,
    fabricFavInfoToShow,
    filterCounts: t1,
    filtersCollectionVisible,
    hideFlyout: t2,
    isClearanceFabricAvailable,
    loading: t3,
    setFiltersCollectionVisible,
    variant
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const filterCounts = t4;
  const hideFlyout = t2 === undefined ? false : t2;
  const loading = t3 === undefined ? false : t3;
  let t5;
  if ($[2] !== className || $[3] !== clearAllFiltersButton || $[4] !== fabricFavInfoToShow || $[5] !== filterCounts || $[6] !== filtersCollectionVisible || $[7] !== hideFlyout || $[8] !== isClearanceFabricAvailable || $[9] !== loading || $[10] !== setFiltersCollectionVisible || $[11] !== variant) {
    t5 = <PDPUpholsteryFiltersUI className={className} clearAllFiltersButton={clearAllFiltersButton} fabricFavInfoToShow={fabricFavInfoToShow} filterCounts={filterCounts} hideFlyout={hideFlyout} isClearanceFabricAvailable={isClearanceFabricAvailable} loading={loading} selectedItem={filtersCollectionVisible} setSelectedItem={setFiltersCollectionVisible} variant={variant} />;
    $[2] = className;
    $[3] = clearAllFiltersButton;
    $[4] = fabricFavInfoToShow;
    $[5] = filterCounts;
    $[6] = filtersCollectionVisible;
    $[7] = hideFlyout;
    $[8] = isClearanceFabricAvailable;
    $[9] = loading;
    $[10] = setFiltersCollectionVisible;
    $[11] = variant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
PDPUpholsteryFilters.propTypes = {
  className: PropTypes.string,
  fabricFavInfoToShow: PropTypes.string,
  filterCounts: productFilterTypes,
  filtersCollectionVisible: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  hideFlyout: PropTypes.bool,
  isClearanceFabricAvailable: PropTypes.bool,
  loading: PropTypes.bool,
  setFiltersCollectionVisible: PropTypes.func,
  variant: PropTypes.string
};
export default PDPUpholsteryFilters;